import SCITellUsMore from './SCITellUsMore';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

// Actions
import { updateAdditionalServicesNotes } from 'store/reducers/selfCheckIn/actions';

// Selectors
import { getAdditionalServicesNotes } from 'store/reducers/selfCheckIn/selectors';

const mapStateToProps = state => {
  return {
    additionalServicesNotes: getAdditionalServicesNotes(state)
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateAdditionalServicesNotes
    },
    dispatch
  );
}

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(SCITellUsMore);



// WEBPACK FOOTER //
// ./src/components/atoms/SCITellUsMore/SCITellUsMoreContainer.js